import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'

import TextHeader from '@abra/elements/table/headers/Text'

const Header = () => <>
  <TableCell align='center'>
    <TextHeader label={I18n.t('order.id', { count: 1 })} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('date.label', { count: 1 })} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('commercialpackage.label', { count: -1 })} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('address.label', { count: -1 })} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={`${I18n.t('designation')} / ${I18n.t('company.label', { count: 1 })}`} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('status.label', { count: 1 })} />
  </TableCell>
</>

export default React.memo(Header)
